
<!--  https://www.tiny.cloud/docs/integrations/vue/ -->
<Editor
  ref="ref_tiny"
  v-bind="$attrs"
  v-on="$listeners"
  tinymce-script-src="/tinymce/tinymce.min.js"
  :init="myInit"
/>
